import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth";
import { getErrorData, handleErrorData, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import Error from "@/views/error/error.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
var initEmailsForm = {
  contact: [],
  contactLimited: [],
  order: [],
  orderLimited: [],
  shipping: [],
  shippingLimited: [],
  accounting: [],
  accountingLimited: [],
  compliance: [],
  complianceLimited: [],
  testing: [],
  testingLimited: [],
  isValid: false
};
var defaultCountryVatAddForm = {
  countryId: 0,
  vatNumber: "",
  isValid: false
};
var defaultCountryVatEditForm = {
  id: 0,
  vatNumber: "",
  isValid: false
};
export default {
  name: "Settings",
  components: {
    Error: Error,
    Confirm: Confirm
  },
  data: function data() {
    return {
      tab: null,
      openedCountries: [],
      emailsDepartment: {
        defaultEmails: {},
        form: Object.deepCopy(initEmailsForm),
        getting: {
          isPending: false
        },
        saving: {
          isPending: false
        }
      },
      identificationNumbers: {
        form: {
          eoriNumber: "",
          fdaNumber: "",
          siretNumber: "",
          ttbNumber: "",
          exciseNumber: "",
          vatIntracomNumber: "",
          isValid: false
        },
        getting: {
          isPending: false
        },
        saving: {
          isPending: false
        },
        countryVat: {
          getting: {
            isPending: false,
            results: []
          },
          adding: {
            isConfiguring: false,
            form: _objectSpread({}, defaultCountryVatAddForm),
            isPending: false,
            availableCountries: []
          },
          updating: {
            isConfiguring: false,
            form: _objectSpread({}, defaultCountryVatEditForm),
            isPending: false
          },
          deleting: {
            isPending: false
          }
        }
      },
      formRules: formRules
    };
  },
  computed: {
    hasAccessToPage: function hasAccessToPage() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_SETTINGS);
    },
    isLoading: function isLoading() {
      return this.emailsDepartment.getting.isPending || this.identificationNumbers.getting.isPending || this.identificationNumbers.countryVat.getting.isPending;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isLoading || this.emailsDepartment.saving.isPending || this.identificationNumbers.saving.isPending || this.identificationNumbers.countryVat.adding.isPending || this.identificationNumbers.countryVat.updating.isPending || this.identificationNumbers.countryVat.deleting.isPending;
    },
    isAnyFormConfiguring: function isAnyFormConfiguring() {
      return this.identificationNumbers.countryVat.adding.isConfiguring || this.identificationNumbers.countryVat.updating.isConfiguring;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.hasAccessToPage) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _this2.getOpenedCountries();
            _this2.getEmailsDepartments();
            _this2.getCompanyIdentificationNumbers();
            _this2.getCountryVatNumbers();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getOpenedCountries: function getOpenedCountries() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _context2.next = 3;
              return request("/v1/countries/protected?implantedMarket=true", "GET", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load countries");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context2.sent;
              _this3.openedCountries = _toConsumableArray(response.data.countries);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getEmailsDepartments: function getEmailsDepartments() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.emailsDepartment.getting.isPending = true;
              _this = _this4;
              _context3.next = 4;
              return request("/v1/departments/all/emails", "get", null, true, "api").catch(function (e) {
                _this.emailsDepartment.getting.isPending = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load emails of departments");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context3.sent;
              _this4.emailsDepartment.form = Object.deepCopy(initEmailsForm);
              response.data.forEach(function (x) {
                var key = x.department.toLowerCase();
                var isLimited = x.countryId > 0;
                if (isLimited) {
                  var _this4$emailsDepartme;
                  var formKey = key + "Limited";
                  var existingLimited = (_this4$emailsDepartme = _this4.emailsDepartment.form[formKey]) === null || _this4$emailsDepartme === void 0 ? void 0 : _this4$emailsDepartme.find(function (y) {
                    return y.countryId === x.countryId && y.stateId === x.stateId;
                  });
                  if (existingLimited) {
                    existingLimited.mails.push(x.mail);
                  } else {
                    var _this4$emailsDepartme2;
                    var newLine = {
                      mails: [x.mail],
                      countryId: x.countryId,
                      stateId: x.stateId,
                      isMainsInCopy: x.isMainsInCopy
                    };
                    (_this4$emailsDepartme2 = _this4.emailsDepartment.form[formKey]) === null || _this4$emailsDepartme2 === void 0 || _this4$emailsDepartme2.push(newLine);
                  }
                } else {
                  var _this4$emailsDepartme3;
                  (_this4$emailsDepartme3 = _this4.emailsDepartment.form[key]) === null || _this4$emailsDepartme3 === void 0 || _this4$emailsDepartme3.push(x.mail);
                }
              });
              _this4.emailsDepartment.defaultEmails = _objectSpread({}, _this4.emailsDepartment.form);
              _this4.emailsDepartment.getting.isPending = false;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updateTags: function updateTags(item) {
      this.emailsDepartment.form[item] = _toConsumableArray(this.emailsDepartment.form[item].filter(function (x) {
        return x !== item;
      }));
    },
    updateTagsLimited: function updateTagsLimited(key, i) {
      this.emailsDepartment.form[key + "Limited"][i].mails = _toConsumableArray(this.emailsDepartment.form[key + "Limited"][i].mails.filter(function (x) {
        return x !== key;
      }));
    },
    resetEmails: function resetEmails() {
      this.emailsDepartment.form = _objectSpread({}, this.emailsDepartment.defaultEmails);
    },
    saveEmails: function saveEmails() {
      this.emailsDepartment.saving.isPending = true;
      var command = {
        emailsDepartment: []
      };
      Object.entries(this.emailsDepartment.form).forEach(function (x) {
        if (x[0] !== "isValid") {
          var department = x[0];
          var isLimited = department.endsWith("Limited");
          if (isLimited) {
            department = department.slice(0, -"Limited".length);
            x[1].forEach(function (y) {
              var newLine = {
                department: department,
                mails: y.mails,
                countryId: y.countryId,
                stateId: y.stateId,
                isMainsInCopy: y.isMainsInCopy
              };
              command.emailsDepartment.push(newLine);
            });
          } else {
            var newLine = {
              department: department,
              mails: x[1]
            };
            command.emailsDepartment.push(newLine);
          }
        }
      });
      var _this = this;
      request("/v1/departments/all/emails", "put", command, true, "api").then(function (_) {
        _this.getEmailsDepartments();
        _this.$toasted.show("Emails saved.", {
          type: "success"
        });
      }).catch(function () {
        var errorData = getErrorData(e, _this.managedExceptions, "Unable to save emails", true);
        handleErrorData(_this, errorData);
        throw e;
      }).finally(function () {
        _this.emailsDepartment.saving.isPending = false;
      });
    },
    addSpecificCountryEmail: function addSpecificCountryEmail(type) {
      var newLine = {
        mails: [],
        countryId: null,
        stateId: null,
        isMainsInCopy: false
      };
      if (type == "contact") {
        this.emailsDepartment.form.contactLimited.push(newLine);
      } else if (type == "order") {
        this.emailsDepartment.form.orderLimited.push(newLine);
      } else if (type == "shipping") {
        this.emailsDepartment.form.shippingLimited.push(newLine);
      } else if (type == "accounting") {
        this.emailsDepartment.form.accountingLimited.push(newLine);
      } else if (type == "compliance") {
        this.emailsDepartment.form.complianceLimited.push(newLine);
      } else if (type == "testing") {
        this.emailsDepartment.form.testingLimited.push(newLine);
      }
    },
    deleteSpecificCountryEmail: function deleteSpecificCountryEmail(type, i) {
      this.emailsDepartment.form[type + "Limited"].splice(i, 1);
    },
    getCompanyIdentificationNumbers: function getCompanyIdentificationNumbers() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.identificationNumbers.getting.isPending = true;
              _this = _this5;
              _context4.next = 4;
              return request("/v1/company-identification-numbers/", "get", null, true, "api").catch(function (e) {
                _this.identificationNumbers.getting.isPending = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load company identification numbers", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context4.sent;
              _this5.identificationNumbers.form = {
                eoriNumber: response.data.value.eoriNumber,
                fdaNumber: response.data.value.fdaNumber,
                siretNumber: response.data.value.siretNumber,
                ttbNumber: response.data.value.ttbNumber,
                exciseNumber: response.data.value.exciseNumber,
                vatIntracomNumber: response.data.value.vatIntracomNumber
              };
              _this5.identificationNumbers.getting.isPending = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    saveIdentificationNumbers: function saveIdentificationNumbers() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.identificationNumbers.saving.isPending = true;
              data = {
                eoriNumber: _this6.identificationNumbers.form.eoriNumber,
                fdaNumber: _this6.identificationNumbers.form.fdaNumber,
                siretNumber: _this6.identificationNumbers.form.siretNumber,
                ttbNumber: _this6.identificationNumbers.form.ttbNumber,
                exciseNumber: _this6.identificationNumbers.form.exciseNumber,
                vatIntracomNumber: _this6.identificationNumbers.form.vatIntracomNumber
              };
              _this = _this6;
              _context5.next = 5;
              return request("/v1/company-identification-numbers/", "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update identification numbers", true);
                handleErrorData(_this, errorData);
                _this.identificationNumbers.saving.isPending = false;
                throw e;
              });
            case 5:
              _this6.$toasted.show("Identification numbers saved.", {
                type: "success"
              });
              _this6.identificationNumbers.saving.isPending = false;
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getCountryVatNumbers: function getCountryVatNumbers() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.identificationNumbers.countryVat.getting.isPending = true;
              _this = _this7;
              _context6.next = 4;
              return request("/v1/company-identification-numbers/country-vat/", "get", null, true, "api").catch(function (e) {
                _this.identificationNumbers.countryVat.getting.isPending = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load country vat numbers", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context6.sent;
              _this7.identificationNumbers.countryVat.getting.results = _toConsumableArray(response.data.value);
              _this7.identificationNumbers.countryVat.getting.isPending = false;
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    startCountryVatAddForm: function startCountryVatAddForm() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var usedCountryIds;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              usedCountryIds = _this8.identificationNumbers.countryVat.getting.results.map(function (x) {
                return x.country.id;
              });
              _this8.identificationNumbers.countryVat.availableCountries = _this8.openedCountries.filter(function (x) {
                return !usedCountryIds.includes(x.id_country);
              });
              _this8.identificationNumbers.countryVat.adding.isConfiguring = true;
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    closeCountryVatAddForm: function closeCountryVatAddForm() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.identificationNumbers.countryVat.adding.isConfiguring = false;
              _this9.identificationNumbers.countryVat.adding.form = _objectSpread({}, defaultCountryVatAddForm);
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    saveCountryVatAddForm: function saveCountryVatAddForm() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this10.identificationNumbers.countryVat.adding.isPending = true;
              data = {
                countryId: _this10.identificationNumbers.countryVat.adding.form.countryId,
                vatNumber: _this10.identificationNumbers.countryVat.adding.form.vatNumber
              };
              _this = _this10;
              _context9.next = 5;
              return request("/v1/company-identification-numbers/country-vat/", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to add country vat", true);
                handleErrorData(_this, errorData);
                _this.identificationNumbers.countryVat.adding.isPending = false;
                throw e;
              });
            case 5:
              _this10.$toasted.show("Identification numbers saved.", {
                type: "success"
              });
              _context9.next = 8;
              return _this10.getCountryVatNumbers();
            case 8:
              _this10.identificationNumbers.countryVat.adding.isPending = false;
              _this10.closeCountryVatAddForm();
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    startCountryVatEditForm: function startCountryVatEditForm(id) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var entity;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              entity = _this11.identificationNumbers.countryVat.getting.results.find(function (x) {
                return x.id === id;
              });
              _this11.identificationNumbers.countryVat.updating.form = {
                id: id,
                vatNumber: entity.vatNumber,
                isValid: false
              };
              _this11.identificationNumbers.countryVat.updating.isConfiguring = true;
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    closeCountryVatEditForm: function closeCountryVatEditForm() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this12.identificationNumbers.countryVat.updating.isConfiguring = false;
              _this12.identificationNumbers.countryVat.updating.form = _objectSpread({}, defaultCountryVatEditForm);
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    saveCountryVatEditForm: function saveCountryVatEditForm() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this13.identificationNumbers.countryVat.updating.isPending = true;
              data = {
                vatNumber: _this13.identificationNumbers.countryVat.updating.form.vatNumber
              };
              _this = _this13;
              _context12.next = 5;
              return request("/v1/company-identification-numbers/country-vat/".concat(_this13.identificationNumbers.countryVat.updating.form.id, "/"), "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to edit country vat", true);
                handleErrorData(_this, errorData);
                _this.identificationNumbers.countryVat.updating.isPending = false;
                throw e;
              });
            case 5:
              _this13.$toasted.show("Country vat updated.", {
                type: "success"
              });
              _context12.next = 8;
              return _this13.getCountryVatNumbers();
            case 8:
              _this13.identificationNumbers.countryVat.updating.isPending = false;
              _this13.closeCountryVatEditForm();
            case 10:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    confirmDeleteCountryVat: function confirmDeleteCountryVat(id) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this14.$refs.confirm.open("Delete country vat", "Are you sure to delete this country vat ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(confirm) {
                  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        if (!confirm) {
                          _context13.next = 3;
                          break;
                        }
                        _context13.next = 3;
                        return _this14.deleteCountryVat(id);
                      case 3:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee13);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    deleteCountryVat: function deleteCountryVat(id) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this15.identificationNumbers.countryVat.deleting.isPending = true;
              _this = _this15;
              _context16.next = 4;
              return request("/v1/company-identification-numbers/country-vat/" + id, "delete", {}, true, "api").catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                    while (1) switch (_context15.prev = _context15.next) {
                      case 0:
                        _this.identificationNumbers.countryVat.deleting.isPending = false;
                        errorData = getErrorData(e, {}, "Unable to cancel this photo.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context15.stop();
                    }
                  }, _callee15);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 4:
              _this15.identificationNumbers.countryVat.deleting.isPending = false;
              _this15.$toasted.show("Country vat deleted.", {
                type: "success"
              });
              _context16.next = 8;
              return _this15.getCountryVatNumbers();
            case 8:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    filterVAutocomplete: filterVAutocomplete,
    hasRole: hasRole
  }
};